import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private secretKey: string = environment.secretPortal;
  private dataReturn!: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  addObjectStorageEcrypted(obj : any,key: string){
    let json = JSON.stringify(obj);
    let data = CryptoJS.AES.encrypt(json, this.secretKey).toString();

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, data);
    }
  }

  getObjectStorageDecrypt(key:string): any  {
    let txtEcrypted = "";

    if (isPlatformBrowser(this.platformId)) {
      txtEcrypted = localStorage.getItem(key) ?? "";
      const bytes = CryptoJS.AES.decrypt(txtEcrypted,this.secretKey);
      const obj = bytes.toString(CryptoJS.enc.Utf8);
    }
    return this.dataReturn;
  }

  add(key:any, value:any){
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }

  get(key:any):any{
    if (isPlatformBrowser(this.platformId)) {
     return localStorage.getItem(key);
    }
  }
  removeItem(key:any){
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.removeItem(key);
     }
  }

  public clearData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
